import { ILambdaLogger, LambdaLogLevel, LogLevel, MapLike, Position, StdLogOutput, ValidBusinessObject, proxyLogger } from '@iotv/iotv-v3-types'
import { SYSTEM } from '../../constants'
import { ThingShadowState } from '../../model/ThingShadowState'
import { ObjectHistory } from '../../model/constructs'
import { CalculateStateFnType } from '../../types'
import { DEBUG_OVERRIDE, NOT_LAMBDA } from '../lambda/debug'

const debug = DEBUG_OVERRIDE || (NOT_LAMBDA && false)
export class CalculatedStateProxy<MT extends ValidBusinessObject, RT extends MapLike<any>> {
  constructor(calculatedStateFn: CalculateStateFnType<MT, RT>, thing: ValidBusinessObject) {
    this.calculatedStateFn = calculatedStateFn
    this.thing = thing
    this.objectHistory = ObjectHistory.createForObject(this.thing, {
      dailyStateHistory: true,
      recentStateHistory: true,
      monthlyStateHistory: true,
      weeklyStateHistory: true,
      yearlyStateHistory: true,
    })
  }

  calculatedStateFn: CalculateStateFnType<MT, RT>
  thing: ValidBusinessObject
  objectHistory: ObjectHistory
  datastore = {
    getAlertOrShadowHistory: () => {
      throw new Error('Not allowed in new versions')
    },
    getOne: async () => {
      debug && console.log('CalculatedStateProxy.getOne returning', SYSTEM)
      return SYSTEM
    },
    getAllFromIndexWithHardLimit: async () => {
      return { Count: 0, ScannedCount: 0, Items: [] }
    },
    getWeatherByLocation: async (location: Position, maxAgeMs: number) => {
      debug && console.log('proxy weather service')
      return { err: null, data: null }
    },
    createUpdate: async () => {
      throw new Error('TODO')
    },
  }

  async processTss(tss: ThingShadowState) {
    const calcStateRes = await this.calculatedStateFn(this.thing as MT, tss, this.objectHistory, proxyLogger)
    const updatedThing = (calcStateRes.data as unknown as { updatedThingObject: ValidBusinessObject | undefined })?.updatedThingObject
    if (updatedThing) this.thing = updatedThing

    return calcStateRes
  }
}
